import _ from "lodash";
import { User } from "../../store/store";

import DOCUMENT_QUERY from "../../graphql/document/Document.gql";

import { containsValidatedReconciliation } from "../../services/documentServices";
import { isInsideClosedAccountingPeriod } from "../../services/accountingPeriods";
import { setCurrentCompany } from "../../services/userServices";
import { NotificationBase } from "../NotificationBase";
import { ComponentBase } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Hook } from "vue-facing-decorator";

@ComponentBase({
    emits: [
        "reload",
        "back",
        "task-ended",
        "previous",
        "next",
        "delete",
        "deleted",
        "openReconciliation",
        "deleted-acr",
    ],
})
export class DocumentRouterBase extends NotificationBase {
    @Prop({ default: "Router" }) mode: string;
    @Prop({ default: false }) Mode: boolean;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) id: string;

    @Prop({ default: false }) previousIdIsset: boolean;
    @Prop({ default: false }) nextIdIsset: boolean;

    /**
     * If true, the icon for back will be displayed (default)
     * If false, the icon for back is not displayed without the mode type
     * @type {boolean}
     * @memberof DocumentBase
     */
    @Prop({ default: true }) goBackHistory: boolean;

    @Hook
    beforeRouteUpdate(to, from, next) {
        this.beforeRouteUpdateOrLeave(next);
    }

    @Hook
    beforeRouteLeave(to, from, next) {
        this.beforeRouteUpdateOrLeave(next);
    }

    zTillReceiptId = "";
    expenseReportId = "";
    // vatDeclarationId = "";
    declarationId = "";
    isAccountingItem = false;

    updating: boolean = false;

    onUpdating(value) {
        this.updating = value;
    }

    initialize() {
        this.document = null;
        this.zTillReceiptId = "";
        this.expenseReportId = "";
        // this.vatDeclarationId = "";
        this.declarationId = "";
        this.isAccountingItem = false;
    }

    get isNotDocument() {
        if (this.isAccountingItem) return true;
        if (this.zTillReceiptId) return true;
        if (this.expenseReportId) return true;
        // if (this.vatDeclarationId) return true;
        if (this.declarationId) return true;
        return false;
    }

    reload() {
        this.onIdChanged(this.id, "");
        this.$emit("reload");
    }

    back() {
        this.$emit("back");
    }

    /**
     * Reloads the current document by calling the onIdChanged method with the current id and an empty string.
     * Used for events on child components.
     */
    reloadDocument() {
        this.onIdChanged(this.id, "");
    }

    @Watch("id")
    async onIdChanged(value, prev) {
        if (value !== prev) {
            this.initialize();
            if (!value) {
                debugger; // git-ignore
            } else {
                try {
                    if (this.$apollo) {
                        const result = await this.$apollo.query({
                            query: DOCUMENT_QUERY,
                            fetchPolicy: "network-only",
                            variables: {
                                documentId: this.id,
                            },
                        });
                        if (result && result.data && result.data.document) {
                            // debugger
                            const cloneDocument = _.cloneDeep(result.data.document);
                            await this.setDocument(cloneDocument);
                            // console.log("result : ", cloneDocument)
                        } else {
                            this.document = null;
                        }
                    } else {
                        console.error("$apollo is null");
                        this.document = null;
                    }
                } catch (e) {
                    console.error(e);
                    debugger; // git-ignore
                    this.document = null;
                }
            }
        }
    }

    async setDocument(document) {
        const lDocument = document as any;
        //
        // if (lDocument.isVatDocumentOf) {
        //     this.vatDeclarationId = lDocument.isVatDocumentOf.id;
        // } else
        if (lDocument.declaration) {
            this.declarationId = lDocument.declaration.id;
        } else if (document.type === "ZTILL_RECEIPT") {
            let zTillReceipt = lDocument.zTillReceipt;
            if (!zTillReceipt) {
                zTillReceipt = lDocument.isDocOfZTillReceipt;
            }
            if (zTillReceipt) {
                if (zTillReceipt.accountingItemImport) {
                    this.isAccountingItem = true;
                    this.document = document;
                } else {
                    this.zTillReceiptId = zTillReceipt.id;
                }
            } else if (lDocument.accountingLinesLocked) {
                this.isAccountingItem = true;
                this.document = document;
            }
        }
        // else if (lDocument.expenseReport) {
        //     this.expenseReportId = lDocument.expenseReport.id
        // }
        else if (lDocument.equalExpenseReport) {
            if (lDocument.equalExpenseReport.accountingItemImport) {
                this.isAccountingItem = true;
                this.document = document;
            } else {
                this.expenseReportId = lDocument.equalExpenseReport.id;
            }
        } else {
            if (lDocument.accountingLinesLocked) {
                this.isAccountingItem = true;
            } else if (
                document.type === "MISCELLANEOUS_OPERATION" ||
                document.type === "WAITING_CASHING" ||
                document.type === "VAT" ||
                (lDocument.accountingItemImport && document.type !== "BANK_STATEMENT")
            ) {
                this.isAccountingItem = true;
            }

            if (document.type === "PURCHASE_INVOICE" && document.thirdPartyAccountableAccount) {
                document.thirdPartyAccountableAccount = { name: "401000" };
            }
            this.document = document;
        }

        if (this.$store.state.user?.allAvailableCompanies?.length) {
            try {
                const documentCompany = this.$store.state.user.allAvailableCompanies.find(
                    (x) => x.id === document.company.id,
                );
                if (documentCompany) {
                    await setCurrentCompany(
                        this.$apollo,
                        this.$store,
                        documentCompany,
                        undefined,
                        true,
                    );
                }
            } catch (e) {
                debugger;
                console.error(e);
            }
        }
    }

    get type() {
        if (this.document) return this.document.type;
        return "";
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get isChat() {
        if (!this.document) return false;
        if (this.document.status === "DENIED" || this.document.status === "DELETED") return false;
        if (this.isNotDocument) return false;
        if (this.isAccountingUser) return false;
        if (
            this.document.chat &&
            this.document.chat.messages &&
            this.document.chat.messages.length
        ) {
            for (const message of this.document.chat.messages) {
                if (message.smartAsk !== null && !message.replyMessage) {
                    return true;
                }
            }
        }
        return false;
    }

    get isEditable() {
        if (!this.documentWrite) {
            return false;
        }
        if (this.document.status.startsWith("ANALYSED")) {
            return true;
        }
        if (this.document.status === "PENDING") {
            return false;
        }
        if (this.document.accountingClosing) {
            return false;
        }
        if (this.document.status === "VALIDATED") {
            if (this.selectedCompany.solution === "MANAGEMENT") {
                return false;
            }
            if (isInsideClosedAccountingPeriod(this.$store, this.document.date)) {
                if (
                    this.document.accountingDate &&
                    isInsideClosedAccountingPeriod(this.$store, this.document.accountingDate)
                ) {
                    return false;
                }
            }
        }
        if (!this.containsValidatedReconciliation) {
            return true;
        }
        return false;
    }

    get isStatic() {
        // debugger;
        if (!this.document) return false;
        if (this.isUnknown) return false;
        if (this.isBankStatement) return false;
        if (this.isSepa) return false;
        if (this.isParentSubscription) return false;
        if (this.isParentLoan) return false;
        if (this.isParentLeasing) return false;
        if (this.isAccountingItem) return true;
        if (this.document.status === "DENIED" || this.document.status === "DELETED") return true;
        if (this.isMiscellaneous) return false;
        if (this.isNotDocument) return false;
        if (this.isChat) return false;

        if (this.document.accountingItemImport) return true;

        if (this.document.status === "UPLOADED" || this.document.status === "ORIGINAL_UPLOADED") {
            return false;
        }
        if (
            this.type === "WITHOUT_INVOICE" ||
            this.type === "WITH_DELTA" ||
            this.type === "BANK_CHARGE" ||
            this.type === "SALES_INVOICE_AUTO" ||
            this.type === "SEPA" ||
            this.type === "SUBSCRIPTION" ||
            this.type === "LOAN" ||
            this.type === "LEASING" ||
            this.type === "SUBSCRIPTION_ACCOUNTING" ||
            this.type === "LOAN_ACCOUNTING" ||
            this.type === "LEASING_ACCOUNTING" ||
            this.type === "QUOTATION"
        ) {
            return true;
        }

        if (this.document.expenseReport && this.document.expenseReport.accountingItemImport) {
            return true;
        }
        if (this.document.invoice) {
            return true;
        }
        if (this.type === "VAT") {
            if (this.document.isVatDocumentOf) {
                return false;
            }
            return true;
        }
        if (
            this.type === "PURCHASE_INVOICE" ||
            this.type === "SALES_INVOICE" ||
            this.type === "EXPENSE_REPORT_DOCUMENT" ||
            this.type === "CURRENT_ACCOUNT" ||
            this.type === "OPERATOR_ACCOUNT"
        ) {
            if (this.document.vatDeclaration) {
                return true;
            }
            // mobile vue
            if (this.$vuetify.display.mobile) {
                return true;
            }
            if (this.isEditable !== undefined) {
                return !this.isEditable;
            }
        }
        return false;
    }

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get documentWrite() {
        if (this.currentUser.profile?.configuration?.document?.write) return true;
        if (this.selectedCompany.solution === "MANAGEMENT") return true;
        return false;
    }

    get toReupload() {
        if (this.document && this.document.status && this.document.status === "PENDING") {
            return true;
        }
        return false;
    }

    get toValidate() {
        if (!this.document) return false;
        if (this.document.status === "DENIED" || this.document.status === "DELETED") return false;
        if (this.isNotDocument) return false;
        if (this.document.accountingItemImport) return false;
        if (this.isChat) return false;
        if (this.document.status === "UPLOADED" || this.document.status === "ORIGINAL_UPLOADED") {
            return false;
        }
        if (
            this.type === "WITHOUT_INVOICE" ||
            this.type === "WITH_DELTA" ||
            this.type === "BANK_CHARGE" ||
            this.type === "PAY_SLIP" ||
            this.type === "SALES_INVOICE_AUTO"
        ) {
            return false;
        }
        if (this.document.expenseReport && this.document.expenseReport.accountingItemImport) {
            return false;
        }
        if (this.document.invoice) {
            return false;
        }
        if (
            this.type === "PURCHASE_INVOICE" ||
            this.type === "SALES_INVOICE" ||
            this.type === "EXPENSE_REPORT_DOCUMENT" ||
            this.type === "CURRENT_ACCOUNT" ||
            this.type === "OPERATOR_ACCOUNT"
        ) {
            if (this.document.vatDeclaration) {
                return false;
            }
            if (this.isEditable !== undefined) {
                return this.isEditable;
            }
        }
        return false;
    }

    get toValidatePaySlip() {
        if (!this.document) return false;
        if (this.document.status === "DENIED" || this.document.status === "DELETED") return false;
        if (this.isNotDocument) return false;
        if (this.document.accountingItemImport) return false;
        if (this.isChat) return false;
        if (this.document.status === "UPLOADED" || this.document.status === "ORIGINAL_UPLOADED") {
            return false;
        }

        if (this.type === "PAY_SLIP") {
            if (this.isEditable !== undefined) {
                return this.isEditable;
            }
        }
        return false;
    }

    get isStaticPaySlip() {
        if (!this.document) return false;
        if (this.document.status === "DENIED" || this.document.status === "DELETED") return false;
        if (this.isNotDocument) return false;
        if (this.document.accountingItemImport) return false;
        if (this.isChat) return false;
        if (this.document.status === "UPLOADED" || this.document.status === "ORIGINAL_UPLOADED") {
            return false;
        }

        if (this.type === "PAY_SLIP") {
            if (this.isEditable !== undefined) {
                return !this.isEditable;
            }
        }
        return false;
    }

    get isMiscellaneous() {
        if (!this.document) return false;
        if (this.document.status === "DENIED" || this.document.status === "DELETED") return false;
        if (this.isNotDocument) return false;
        if (this.document.accountingItemImport) return false;
        if (this.isChat) return false;
        if (this.isBankStatement) return false;
        if (this.isSepa) return false;
        if (this.isParentSubscription) return false;
        if (this.isParentLoan) return false;
        if (this.isParentLeasing) return false;
        if (
            this.type === "WITHOUT_INVOICE" ||
            this.type === "WITH_DELTA" ||
            this.type === "BANK_CHARGE" ||
            this.type === "SALES_INVOICE_AUTO" ||
            this.type === "UNKNOWN"
        ) {
            return false;
        }
        if (this.document.status === "UPLOADED" || this.document.status === "ORIGINAL_UPLOADED") {
            return true;
        }
        return this.document.type === "MISCELLANEOUS";
    }

    get isBankStatement() {
        if (!this.document) return false;
        if (this.isChat) return false;
        return this.document.type === "BANK_STATEMENT";
    }

    get isSepa() {
        if (!this.document) return false;
        if (this.isChat) return false;
        return this.document.type === "SEPA";
    }

    get isParentSubscription() {
        if (!this.document) return false;
        // Cette condition s'applique pour les documents de type "SUBSCRIPTION" qui ont été restaurés et donc ne sont plus liés à un autre document ( provisoire )
        // if (this.document.type === "SUBSCRIPTION" && !this.document.fromDocument && !this.document.fromDocumentOf.length) {
        //     return false
        // }
        return this.document.type === "SUBSCRIPTION" && !this.document.fromDocument;
    }

    get isParentLoan() {
        if (!this.document) return false;
        return this.document.type === "LOAN" && !this.document.fromDocument;
    }

    get isParentLeasing() {
        if (!this.document) return false;
        return this.document.type === "LEASING" && !this.document.fromDocument;
    }

    get isUnknown() {
        if (!this.document) return false;
        return this.type === "UNKNOWN";
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    beforeMount() {
        this.onIdChanged(this.id, null);
        this.addListener("document");
    }

    beforeDestroy() {
        this.removeListener();
    }

    onMessage(data) {
        // console.log("on message document")
        if (this.updating) {
            return;
        }
        if (data?.id === this.document?.id) {
            const updatedDocument = data.payload;
            // if (this.document.type !== updatedDocument.type || this.document.status !== updatedDocument.status || !updatedDocument.status?.startsWith('ANALYSED')) {
            if (
                this.document.status !== updatedDocument.status &&
                (!this.document.status?.startsWith("ANALYSED") ||
                    !updatedDocument.status?.startsWith("ANALYSED"))
            ) {
                this.onIdChanged(data.id, "");
            }
        }
    }

    document: any = null;

    onTaskEnded(data) {
        console.log("onTaskEnded", this.mode);
        if (this.mode === "Router") {
            this.onIdChanged(this.id, null);
        } else {
            this.$emit("task-ended", data);
        }
    }

    onEdit() {
        this.onIdChanged(this.id, null);
    }

    previous() {
        this.$emit("previous");
    }

    next() {
        this.$emit("next");
    }

    deleted() {
        debugger;
        this.$emit("deleted");
    }

    /**
     * Emit event deleted-acr when the document is deleted
     * with an alacr untied
     */
    deletedAcr() {
        this.$emit("deleted-acr");
    }

    get containsValidatedReconciliation() {
        return containsValidatedReconciliation(this.document);
    }

    openReconciliation(data) {
        this.$emit("openReconciliation", data);
    }

    routeNext = null;
    beforeRouteLeaveDialog = false;

    beforeRouteUpdateOrLeave(next) {
        next();
        // this.beforeRouteLeaveDialog = true
        // this.routeNext = next
    }
}
